import { DEFAULT_VOID_REASON } from "../../../constants";

const getFieldError = (field, value) => {
  switch (field) {
    case "comment":
      return value && value.trim() ? null : "* Required";
    default:
      return null;
  }
};

const getErrorInfo = (errorInfo, voidPickupData) => {
  const newErrorInfo = {};
  Object.keys(errorInfo).forEach((fieldName) => {
    newErrorInfo[fieldName] = getFieldError(
      fieldName,
      voidPickupData[fieldName]
    );
  });
  return newErrorInfo;
};

const getDefaultVoidPickData = () => ({
  voidReason: DEFAULT_VOID_REASON,
  comment: null,
  errorInfo: {
    comment: null,
  },
});

export { getFieldError, getErrorInfo, getDefaultVoidPickData };
